export type BrowserAutomationSignals = {
  webdriver?: boolean;
  userAgent?: string;
  hasChrome?: boolean;
};

const AUTOMATION_USER_AGENT =
  /bot|crawler|spider|slurp|bingpreview|prerender|lighthouse|pagespeed|gtmetrix|puppeteer|playwright|selenium|webdriver|cypress/i;
const CLASSIC_HEADLESS_USER_AGENT =
  /\b(?:HeadlessChrome|PhantomJS|HtmlUnit|Electron)\b/i;
const CHROME_USER_AGENT = /\bChrome\/\d+/i;

export function isAutomatedBrowser(
  signals: BrowserAutomationSignals = browserAutomationSignals(),
): boolean {
  const userAgent = signals.userAgent ?? "";
  return (
    signals.webdriver === true ||
    AUTOMATION_USER_AGENT.test(userAgent) ||
    CLASSIC_HEADLESS_USER_AGENT.test(userAgent) ||
    (CHROME_USER_AGENT.test(userAgent) && signals.hasChrome === false)
  );
}

function browserAutomationSignals(): BrowserAutomationSignals {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {};
  }
  return {
    webdriver: navigator.webdriver,
    userAgent: navigator.userAgent,
    hasChrome: "chrome" in window,
  };
}